import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randNumber,
  randChanceBoolean,
  randPhrase,
  randPastDate,
} from '@ngneat/falso'

type RefillItemTypeCode = 'MEDICINE' | 'SUPPLY' | 'FOOD'

type RefillItemAttributes = {
  name: string
  quantity: number
  units: number
  usage_size: number
  instructions: string | null
  display_amount: string
  display_unit: string
  created: string
  modified: string
  is_expired: boolean
  item_archived: boolean
  item_id: number | null
  item_type: RefillItemTypeCode | null
}

export const model = (Model as ModelDefinition<RefillItemAttributes>).extend({})

export const factory = Factory.extend<RefillItemAttributes>({
  name() {
    return '' // Will be set from parent
  },
  quantity() {
    return randNumber({ min: 1, max: 100 })
  },
  units() {
    return randNumber({ min: 1, max: 10 })
  },
  usage_size() {
    return randNumber({ min: 1, max: 5 })
  },
  instructions() {
    return randChanceBoolean({ chanceTrue: 0.7 }) ? randPhrase() : null
  },
  display_amount() {
    return '' // Will be computed from quantity
  },
  display_unit() {
    const units = ['mg', 'ml', 'tablets', 'capsules', 'g', 'units']
    return rand(units)
  },
  created() {
    return randPastDate({ years: 1 }).toISOString()
  },
  modified() {
    return randPastDate({ years: 1 }).toISOString()
  },
  is_expired() {
    return false // Will be set from parent based on status
  },
  item_archived() {
    return randChanceBoolean({ chanceTrue: 0.05 })
  },
  item_id() {
    return randNumber({ min: 1, max: 1000 })
  },
  item_type() {
    return rand(['MEDICINE', 'SUPPLY', 'FOOD']) as RefillItemTypeCode
  },
})
